module.exports = __webpack_public_path__ + "3f16e137/img/question-icon.06c20c5d.svg";